 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","add-address-add-address-module":"add-address-add-address-module","brand-faq-brand-faq-module":"brand-faq-brand-faq-module","delivery-login-delivery-login-module":"delivery-login-delivery-login-module","delivery-login-revise-delivery-login-revise-module":"delivery-login-revise-delivery-login-revise-module","login-court-login-court-module":"login-court-login-court-module","login-login-module":"login-login-module","pages-delivery-information-delivery-information-module":"pages-delivery-information-delivery-information-module","pages-limited-access-limited-access-module":"pages-limited-access-limited-access-module","pages-search-item-search-item-module":"pages-search-item-search-item-module","pages-test-test-module":"pages-test-test-module","pop-up-set-menu-pop-up-set-menu-module":"pop-up-set-menu-pop-up-set-menu-module","pop-up-set-menu-withImg-pop-up-set-menu-withImg-page-module":"pop-up-set-menu-withImg-pop-up-set-menu-withImg-page-module","registration-court-registration-court-module":"registration-court-registration-court-module","registration-registration-module":"registration-registration-module","verify-registration-court-verify-registration-court-module":"verify-registration-court-verify-registration-court-module","verify-registration-verify-registration-module":"verify-registration-verify-registration-module","default~alipay-payment-alipay-payment-module~cash-payment-cash-payment-module~credit-card-payment-cr~af2d1025":"default~alipay-payment-alipay-payment-module~cash-payment-cash-payment-module~credit-card-payment-cr~af2d1025","alipay-payment-alipay-payment-module":"alipay-payment-alipay-payment-module","cash-payment-cash-payment-module":"cash-payment-cash-payment-module","eft-payment-eft-payment-module":"eft-payment-eft-payment-module","full-points-payment-full-points-payment-module":"full-points-payment-full-points-payment-module","mid-trans-payment-mid-trans-payment-module":"mid-trans-payment-mid-trans-payment-module","mpgs-credit-card-payment-mpgs-credit-card-payment-module":"mpgs-credit-card-payment-mpgs-credit-card-payment-module","omise-creditcard-payment-omise-creditcard-payment-module":"omise-creditcard-payment-omise-creditcard-payment-module","openrice-payment-openrice-payment-module":"openrice-payment-openrice-payment-module","redirect-payment-redirect-payment-module":"redirect-payment-redirect-payment-module","reward-payment-reward-payment-module":"reward-payment-reward-payment-module","stripe-google-pay-payment-stripe-google-pay-payment-module":"stripe-google-pay-payment-stripe-google-pay-payment-module","wechat-open-payment-wechat-open-payment-module":"wechat-open-payment-wechat-open-payment-module","wechat-pay-payment-wechat-pay-payment-module":"wechat-pay-payment-wechat-pay-payment-module","wirecard-v2-payment-wirecard-v2-payment-module":"wirecard-v2-payment-wirecard-v2-payment-module","default~byod-summary-byod-summary-module~cart-cart-module~cart-cart-scroll-cart-scroll-module~mpgs-a~bb74ff16":"default~byod-summary-byod-summary-module~cart-cart-module~cart-cart-scroll-cart-scroll-module~mpgs-a~bb74ff16","stripe-apple-payment-stripe-apple-payment-module":"stripe-apple-payment-stripe-apple-payment-module","default~mpgs-apple-pay-payment-mpgs-apple-pay-payment-module~mpgs-google-pay-payment-mpgs-google-pay~847c5a33":"default~mpgs-apple-pay-payment-mpgs-apple-pay-payment-module~mpgs-google-pay-payment-mpgs-google-pay~847c5a33","default~cart-cart-module~cart-cart-scroll-cart-scroll-module~multi-order-cart-multi-order-cart-modul~67f25521":"default~cart-cart-module~cart-cart-scroll-cart-scroll-module~multi-order-cart-multi-order-cart-modul~67f25521","default~cart-cart-module~cart-cart-scroll-cart-scroll-module~multi-order-cart-multi-order-cart-modul~d96ace7b":"default~cart-cart-module~cart-cart-scroll-cart-scroll-module~multi-order-cart-multi-order-cart-modul~d96ace7b","default~brand-store-list-brand-store-list-module~multi-order-cart-multi-order-cart-module":"default~brand-store-list-brand-store-list-module~multi-order-cart-multi-order-cart-module","default~multi-order-cart-multi-order-cart-module~oepay-payment-oepay-payment-module":"default~multi-order-cart-multi-order-cart-module~oepay-payment-oepay-payment-module","multi-order-cart-multi-order-cart-module":"multi-order-cart-multi-order-cart-module","default~mpgs-apple-pay-payment-mpgs-apple-pay-payment-module~summary-list-summary-list-module":"default~mpgs-apple-pay-payment-mpgs-apple-pay-payment-module~summary-list-summary-list-module","mpgs-apple-pay-payment-mpgs-apple-pay-payment-module":"mpgs-apple-pay-payment-mpgs-apple-pay-payment-module","oepay-payment-oepay-payment-module":"oepay-payment-oepay-payment-module","default~credit-card-payment-credit-card-payment-module~mpgs-host-session-mpgs-host-session-module":"default~credit-card-payment-credit-card-payment-module~mpgs-host-session-mpgs-host-session-module","credit-card-payment-credit-card-payment-module":"credit-card-payment-credit-card-payment-module","mpgs-host-session-mpgs-host-session-module":"mpgs-host-session-mpgs-host-session-module","mpgs-google-pay-payment-mpgs-google-pay-payment-module":"mpgs-google-pay-payment-mpgs-google-pay-payment-module","brand-store-list-brand-store-list-module":"brand-store-list-brand-store-list-module","byod-summary-byod-summary-module":"byod-summary-byod-summary-module","default~cart-cart-module~cart-cart-scroll-cart-scroll-module":"default~cart-cart-module~cart-cart-scroll-cart-scroll-module","cart-cart-module":"cart-cart-module","cart-cart-scroll-cart-scroll-module":"cart-cart-scroll-cart-scroll-module","default~pages-byod-brand-splash-byod-brand-splash-module~pages-byod-splash-byod-splash-module~pages-~b6cb545e":"default~pages-byod-brand-splash-byod-brand-splash-module~pages-byod-splash-byod-splash-module~pages-~b6cb545e","pages-store-list-store-list-page-module":"pages-store-list-store-list-page-module","default~order-status-order-status-module~pages-byod-splash-byod-splash-module":"default~order-status-order-status-module~pages-byod-splash-byod-splash-module","pages-byod-splash-byod-splash-module":"pages-byod-splash-byod-splash-module","default~item-grid-item-grid-module~item-grid-scroll-item-grid-scroll-module~pages-top-menu-category-~a75d378c":"default~item-grid-item-grid-module~item-grid-scroll-item-grid-scroll-module~pages-top-menu-category-~a75d378c","default~item-grid-item-grid-module~item-grid-scroll-item-grid-scroll-module":"default~item-grid-item-grid-module~item-grid-scroll-item-grid-scroll-module","item-grid-item-grid-module":"item-grid-item-grid-module","default~item-grid-scroll-item-grid-scroll-module~pages-top-menu-category-list-top-menu-category-list~95e575cb":"default~item-grid-scroll-item-grid-scroll-module~pages-top-menu-category-list-top-menu-category-list~95e575cb","pages-top-menu-category-list-top-menu-category-list-module":"pages-top-menu-category-list-top-menu-category-list-module","item-grid-scroll-item-grid-scroll-module":"item-grid-scroll-item-grid-scroll-module","multi-order-history-multi-order-history-module":"multi-order-history-multi-order-history-module","summary-list-summary-list-module":"summary-list-summary-list-module","order-status-order-status-module":"order-status-order-status-module","pages-byod-brand-splash-byod-brand-splash-module":"pages-byod-brand-splash-byod-brand-splash-module","default~pages-category-group-list-category-group-list-module~pages-category-item-list-category-item-~a008421c":"default~pages-category-group-list-category-group-list-module~pages-category-item-list-category-item-~a008421c","pages-category-group-list-category-group-list-module":"pages-category-group-list-category-group-list-module","pages-category-item-list-category-item-list-module":"pages-category-item-list-category-item-list-module","pages-category-list-category-list-module":"pages-category-list-category-list-module","pages-side-menu-category-list-side-menu-category-list-page-module":"pages-side-menu-category-list-side-menu-category-list-page-module","dinein-or-takeaway-page-dinein-or-takeaway-page-module":"dinein-or-takeaway-page-dinein-or-takeaway-page-module","member-reward-court-member-reward-court-module":"member-reward-court-member-reward-court-module","member-reward-member-reward-module":"member-reward-member-reward-module","member-reward-new-member-reward-new-module":"member-reward-new-member-reward-new-module","modifier-item-select-modifier-item-select-module":"modifier-item-select-modifier-item-select-module","multi-order-detail-multi-order-detail-module":"multi-order-detail-multi-order-detail-module","order-detail-order-detail-module":"order-detail-order-detail-module","pages-close-close-module":"pages-close-close-module","pages-code-code-page-module":"pages-code-code-page-module","pages-external-web-close-external-web-close-module":"pages-external-web-close-external-web-close-module","pages-qr-code-qr-code-module":"pages-qr-code-qr-code-module","pages-scan-qrcode-scan-qrcode-module":"pages-scan-qrcode-scan-qrcode-module","pages-verify-table-code-verify-table-code-module":"pages-verify-table-code-verify-table-code-module","phone-verification-phone-verification-module":"phone-verification-phone-verification-module","profile-court-profile-court-module":"profile-court-profile-court-module","profile-profile-module":"profile-profile-module","reset-password-court-reset-password-court-module":"reset-password-court-reset-password-court-module","reset-password-reset-password-module":"reset-password-reset-password-module","reward-list-reward-list-module":"reward-list-reward-list-module","saved-order-list-saved-order-list-module":"saved-order-list-saved-order-list-module","set-sub-items-set-sub-items-module":"set-sub-items-set-sub-items-module","src-app-dialogs-address-dialog-address-dialog-module":"src-app-dialogs-address-dialog-address-dialog-module","summary-order-status-prekiosk-order-status-prekiosk-module":"summary-order-status-prekiosk-order-status-prekiosk-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
